import React from 'react'
import c from './ImageSlide.module.scss'

interface ImageSlideProps {
  imageUrl: string
}

function ImageSlide({ imageUrl }: ImageSlideProps) {
  return <img className={c.image} src={imageUrl} alt="" />
}

export default ImageSlide
